import React, { useState } from "react";
import styles from "./styles/UserMgtUpdateForm.module.css";
import CreateIcon from "@mui/icons-material/Create";
import { Paper,  PaperClassKey} from "@mui/material";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import LandscapeOutlinedIcon from "@mui/icons-material/LandscapeOutlined";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import {
//   RetailerUpdateUserMgt,
//   UpdateUserMgt,
// } from "../../../actions/UserMgt/UserMgt";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {ShopBaseImgUrl } from "../../utility/BaseURL";

import { TableconvertDate } from "../Functions/function";
import useRetailerList from "../../hooks/useRetailerList";
import useUpdateRetailer from "../../hooks/useUpdateRetailer";
import useMapData from "../../hooks/useMapData";


const useStyles = makeStyles((theme) => ({
  TextField: {
    color: "black",
  },
}));

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#DC1D13" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const RedButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: "#DC1D13",
  "&:hover": {
    backgroundColor: "#DC1D13",
  },
}));

const GrayButton = styled(Button)(({ theme }) => ({
  color: "#404040",
  backgroundColor: "#E5E5E5",
  "&:hover": {
    backgroundColor: "#E5E5E5",
  },
}));

const UserMgtUpdateForm = ({ zone }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [token, setToken] = useState("");
  const [form, setForm] = useState({});
  const [formError, setFormError] = useState({});
//   const list = useSelector((state) => state.UserMgt.retailerlist);
  const Firsttoken = useSelector((state) => state.Token);
  const [Zone, setZone] = React.useState("");
  const [edit, setEdit] = useState(false);

  const [Role, setRole] = React.useState("");
  const userData = useSelector((state) => state?.login?.refreshToken?.user_data);
  const retailerDetails=useSelector((store)=>store.retailer.retailerUserDetails)
  const DropDownData = useSelector((state) =>state.app.curretDropdownData);
  const [StatusList, setStatusList] = useState([
    "active",   
    "inactive",
  ]);
  const [Status, setStatus] = React.useState("");

  const [Updatesuccess, setUpdatesuccess] = useState(false);
  const [obj, setObj] = useState({
    failed: false,
    message: "",
  });
  const [invalidToken, setInvalidToken] = useState(false);

  React.useEffect(() => {
    if (retailerDetails && retailerDetails !== "undefined") {
      setForm(retailerDetails);
      setZone(retailerDetails.zone_name);
      setRole(retailerDetails.role_name);
      setStatus(retailerDetails.status);
    }
  }, [retailerDetails]);

  React.useEffect(() => {
    if (
      Firsttoken &&
      Firsttoken.token &&
      Firsttoken.token !== null &&
      Firsttoken.token.length !== 0 &&
      Firsttoken !== "undefined"
    ) {
      setToken(Firsttoken.token);
    }
  }, [Firsttoken]);

   
  const IsValid = () => {
    let success = true;
    let error = {};

    // console.log(form);

    if (!form.zone_name.trim()) {
      error.zone = "Zone cannot be empty";
      success = false;
    }

    if (!form.name.trim()) {
      error.name = "name cannot be empty";
      success = false;
    }
    if (!form.surname.trim()) {
      error.surname = "surname cannot be empty";
      success = false;
    }
    // if (!form.mobile_no?.toString().trim()) {
    //     error.mobileno = "mobileno cannot be empty";
    //     success = false;
    // }
    // else if (!(/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/g).test(form.mobile_no)) {
    //     error.mobileno = "Enter a Valid mobileno Number";
    //     success = false
    // }
    // if (!form.whatsapp_no?.toString().trim()) {
    //     error.whatsappno = "whatsappno cannot be empty";
    //     success = false;
    // }
    // else if (!(/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/g).test(form.whatsapp_no)) {
    //     error.whatsappno = "Enter a Valid whatsapp Number";
    //     success = false
    // }

    if (!form.address.trim()) {
      error.address = "address cannot be empty";
      success = false;
    }
    if (!form.lati?.toString().trim()) {
      error.latitude = "latitude cannot be empty";
      success = false;
    }
    if (!form.longi.toString().trim()) {
      error.longitude = "longitude cannot be empty";
      success = false;
    }


    setFormError(error);
    return success;
  };



  const handleStatusChange = (event) => {
    console.log(event.target.value, "event.target.value");
  
    // Check if the selected value is "rejected"
    const newUserStatus = event.target.value === 'rejected' ? 'inactive_reported' : event.target.value;
  
    // Update the form with the new user_status value
    setForm({ ...form, user_status: newUserStatus });
  }

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  let param = {
    admin_id: "1",
    retailer_id: form?.user_id,
    route_id: form?.route_id,
    name: form?.name,
    surname: form?.surname,
    mobile_no: form?.mobile_no,
    whatsapp_no: form?.whatsapp_no,
    address: form?.address,
    landmark: form?.landmark,
    shop_name: form?.shop_name,
    capacity: form?.capacity,
    village_id: form?.village_id,
    status: Status,
  };

  // console.log(param, "param", form);

  //   const handleUpdate = async (e) => {
  //     e.preventDefault();
  //     if (IsValid()) {
  //       const data = await dispatch(RetailerUpdateUserMgt(token, param, form));
  //       console.log(data, "data");

  //       if (data.code === 200) {
  //         console.log("here");
  //         toast.success("SuccessFully Updated Retailer");
  //         setEdit(false);
  //       } else {
  //         toast.error(data.message);
  //       }
  //     }
  //   };
   
  
  
  const handleCancel = () => {
    setEdit(false);
    // if (detail && detail !== "undefined") {
    //   setForm(detail);
    //   setZone(detail.zone_name);
    //   setRole(detail.role_name);
    //   setStatus(detail.status);
    // }
  };
  
  React.useEffect(() => {
    if (invalidToken) {
      toast.warning("Invalid Token");
      setInvalidToken(false);
    }
  }, [invalidToken]);

  const handleEdit = () => {
    if(userData?.demo){
      toast.error("You are not authorized to perform this action");
      return;
    }else{
      setEdit(!edit);
    }
  };
  const updateRetailer = useUpdateRetailer(form);
  // const getRetailerList = useRetailerList();
  const getMapData = useMapData();
  const handleUpdate = async(event) => {
    let param = {
      zone_id: DropDownData?.zone_id,
    };
    event.preventDefault(); 
    await updateRetailer();
    // await getRetailerList();
    await getMapData(param);
  };
  
  // console.log(Status, form);
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <form onSubmit={handleUpdate}>
        <div id="UserMgtRetailerDetail" >
          <div className={styles.UserMgtUpdateFormContainer} style={{gap:"1.5rem"}}>
            {/* {list && list.length !== 0 ? ( */}
              <>
                <div className={styles.UserMgtUpdateFormContainerOne}>
                  {/* <div className={styles.UserMgtUpdateFormContainerSectionOne}>
                                    <div className={styles.UserMgtUpdateFormSectionOneTitleContainer}>
                                        <label className={styles.UserMgtUpdateFormSectionOneTitle}>User Details</label>
                                    </div>
   
                                </div> */}

                  <div className={styles.UserMgtUpdateFormContainerSectionOneM}>
                    <div
                      className={
                        styles.UserMgtUpdateFormSectionOneTitleContainer
                      }
                    >
                      <label
                        className={styles.UserMgtUpdateFormSectionOneTitle}
                      >
                        {retailerDetails?.shop_name}
                      </label>
                    </div>
                    {!edit ? (
                      <div
                        className={
                          styles.UserMgtUpdateFormSectionOneEditContainer
                        }
                        onClick={handleEdit}
                      >
                        <CreateIcon
                          className={styles.UserMgtUpdateFormSectionOneEditIcon}
                        />
                      </div>
                    ) : null}
                  </div>

                  <div className={styles.UserMgtUpdateFormContainerSectionTwo}>
                    <div className={styles.UserMgtUpdateFormTwoSubSectionOne}>
                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Zone
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input 
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            disabled={!edit}
                            value={retailerDetails?.zone_name}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />

                          {formError.zone && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.zone}
                            </span>
                          )}
                        </div>
                      </div>

                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                           Retailer ID
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            disabled={!edit}
                            value={retailerDetails?.retailer_id}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />
                          {formError.userid && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.userid}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Role
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            disabled={!edit}
                            value="Retailer"
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />

                          {formError.role && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.role}
                            </span>
                          )}
                        </div>
                      </div> */}

                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Name
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            disabled={edit ? false : true}
                            value={form?.first_name}
                            name="first_name"
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                            onChange={handleChange}
                          />
                          {formError.name && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.name}
                            </span>
                          )}
                        </div>
                      </div>

                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Surname
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            value={form?.last_name}
                            disabled={edit ? false : true}
                            name="last_name"
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                            onChange={handleChange}
                          />
                          {formError.surname && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.surname}
                            </span>
                          )}
                        </div>
                      </div>

                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Mobile No
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            value={retailerDetails?.mobile_no}
                            disabled={!edit}
                            name="mobile_no"
                            onChange={handleChange}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />
                          {formError.mobileno && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.mobileno}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Whatsapp ID
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input 
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            value={retailerDetails?.mobile_no}
                            disabled={!edit}
                            name="whatsapp_no"
                            onChange={handleChange}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />
                          {formError.whatsappno && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.whatsappno}
                            </span>
                          )}
                        </div>
                      </div> */}
                    </div>
                    <div className={styles.UserMgtUpdateFormTwoSubSectionTwo}>
                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Address
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            value={retailerDetails?.address}
                            disabled={!edit}
                            multiline
                            rows={3}
                            name="address"
                            onChange={handleChange}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />
                          {formError.address && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.address}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* {zone.toLowerCase() !== "raipur" ? ( */}
                        <>
                          <div
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneList
                            }
                          >
                            <div
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListOne
                              }
                            >
                              <label
                                className={
                                  styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                                }
                              >
                                Latitude
                              </label>
                            </div>
                            <div
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                              }
                            >
                              <input 
                              style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                                variant="outlined"
                                size="small"
                                value={retailerDetails?.lat}
                                disabled={!edit}
                                className={
                                  styles.UserMgtUpdateFormTwoSubSectionOneListField
                                }
                              />
                              {formError.latitude && (
                                <span
                                  className={
                                    styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                                  }
                                >
                                  {formError.latitude}
                                </span>
                              )}
                            </div>
                          </div>

                          <div
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneList
                            }
                          >
                            <div
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListOne
                              }
                            >
                              <label
                                className={
                                  styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                                }
                              >
                                Longitude
                              </label>
                            </div>
                            <div
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                              }
                            >
                              <input
                              style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                                variant="outlined"
                                size="small"
                                disabled={!edit}
                                value={retailerDetails?.lng}
                                className={
                                  styles.UserMgtUpdateFormTwoSubSectionOneListField
                                }
                              />
                              {formError.longitude && (
                                <span
                                  className={
                                    styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                                  }
                                >
                                  {formError.longitude}
                                </span>
                              )}
                            </div>
                          </div>
                        </>
                      {/* ) : null} */}

                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            status
                          </label>
                        </div>
                        {!edit ? (
                          <div
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                            }
                          >
                            <input 
                            style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                              variant="outlined"
                              size="small"
                              disabled={!edit}
                              value={retailerDetails?.user_status === 'inactive_reported' ? 'rejected' : form.user_status}
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListField
                              }
                            />
                          </div>
                        ) : (
                          <div
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                            }
                          >
                            <Box sx={{ minWidth: 120, maxWidth: "100%" }}>
                              <FormControl fullWidth>
                                <Select
                                  value={form.user_status === 'inactive_reported' ? 'rejected' : form.user_status}
                                  onChange={handleStatusChange}
                                  // size="small"
                                  sx={{height:"1.8rem"}}
                                >
                                  {StatusList &&
                                    StatusList.length !== 0 &&
                                    StatusList !== "undefined" &&
                                    StatusList !== null &&
                                    StatusList.map((item, index) => (
                                      <MenuItem value={item} key={index}>{item}</MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </Box>
                          </div>
                        )}
                      </div>

                      {/* <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            Route ID
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input 
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            value={form.route_id}
                            disabled={!edit}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />
                          {formError.routeid && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.routeid}
                            </span>
                          )}
                        </div>
                      </div> */}

                      <div
                        className={styles.UserMgtUpdateFormTwoSubSectionOneList}
                      >
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListOne
                          }
                        >
                          <label
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListLabel
                            }
                          >
                            TimeStamp
                          </label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormTwoSubSectionOneListTwo
                          }
                        >
                          <input 
                          style={{height: "1.8rem",background:"white",border:"1px solid rgba(0, 0, 0, 0.2)"}}
                            variant="outlined"
                            size="small"
                            value={TableconvertDate(retailerDetails?.to_char)}
                            disabled={!edit}
                            className={
                              styles.UserMgtUpdateFormTwoSubSectionOneListField
                            }
                          />
                          {formError.timestamp && (
                            <span
                              className={
                                styles.UserMgtUpdateFormTwoSubSectionOneListTwoErrorLabel
                              }
                            >
                              {formError.timestamp}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Paper sx={{ flex: "0.9", padding: "5px" }}>
                  <div className={styles.UserMgtUpdateFormContainerTwo}>
                    <div
                      className={
                        styles.UserMgtUpdateFormContainerTwoFirmContainer
                      }
                    >
                      <img
                        src={
                          form &&
                          form.shop_image &&
                          form.shop_image !== "undefined" &&
                          form.shop_image !== null
                            ? `${form.shop_image}`
                            : "https://i.guim.co.uk/img/media/24b25c23b97e37af3892230202b98b8ac20a10e0/0_31_5550_3330/master/5550.jpg?width=445&quality=45&auto=format&fit=max&dpr=2&s=389ec7167a0686c3ed084d7487c5be2c"
                        }
                        alt="firm"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        marginTop: "-60px",
                      }}
                    >
                      <div
                        className={
                          styles.UserMgtUpdateFormContainerTwoProfileContainer
                        }
                      >
                        <img
                          className={
                            styles.UserMgtUpdateFormContainerTwoProfile
                          }
                          src={
                            form &&
                            retailerDetails?.profile_image &&
                            retailerDetails?.profile_image !== "undefined" &&
                            retailerDetails?.profile_image !== null
                              ? `${retailerDetails?.profile_image}`
                              : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEpWWQrAJpIR6Xy7FhzhCT00vzSmT7xw9S2Q&usqp=CAU"
                          }
                          alt="prof"
                        />
                      </div>
                    </div>

                    <div
                      className={
                        styles.UserMgtUpdateFormContainerTwoListContainer
                      }
                    >
                      <div className={styles.UserMgtUpdateFormContainerTwoList}>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListOne
                          }
                        >
                          <span
                            className={
                              styles.UserMgtUpdateFormContainerTwoListOneIconContainer
                            }
                          >
                            <PersonOutlineIcon
                              className={
                                styles.UserMgtUpdateFormContainerTwoListOneIcon
                              }
                            />
                          </span>
                          <label>Name</label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListTwo
                          }
                        >
                          {form?.first_name}{" "}
                          {form?.last_name}
                        </div>
                      </div>

                      <div className={styles.UserMgtUpdateFormContainerTwoList}>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListOne
                          }
                        >
                          <span
                            className={
                              styles.UserMgtUpdateFormContainerTwoListOneIconContainer
                            }
                          >
                            <CallOutlinedIcon
                              className={
                                styles.UserMgtUpdateFormContainerTwoListOneIcon
                              }
                            />
                          </span>
                          <label>Mobile</label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListTwo
                          }
                        >
                          {retailerDetails?.mobile_no}
                        </div>
                      </div>

                      <div className={styles.UserMgtUpdateFormContainerTwoList}>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListOne
                          }
                        >
                          <span
                            className={
                              styles.UserMgtUpdateFormContainerTwoListOneIconContainer
                            }
                          >
                            <LandscapeOutlinedIcon
                              className={
                                styles.UserMgtUpdateFormContainerTwoListOneIcon
                              }
                            />
                          </span>
                          <label>zone</label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListTwo
                          }
                        >
                          {retailerDetails?.zone_name}
                        </div>
                      </div>

                      <div className={styles.UserMgtUpdateFormContainerTwoList}>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListOne
                          }
                        >
                          <span
                            className={
                              styles.UserMgtUpdateFormContainerTwoListOneIconContainer
                            }
                          >
                            <RoomOutlinedIcon
                              className={
                                styles.UserMgtUpdateFormContainerTwoListOneIcon
                              }
                            />
                          </span>
                          <label>Address</label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListTwo
                          }
                        >
                          {retailerDetails?.address}
                        </div>
                      </div>

                      {/* <div className={styles.UserMgtUpdateFormContainerTwoList}>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListOne
                          }
                        >
                          <span
                            className={
                              styles.UserMgtUpdateFormContainerTwoListOneIconContainer
                            }
                          >
                            <EditLocationAltOutlinedIcon
                              className={
                                styles.UserMgtUpdateFormContainerTwoListOneIcon
                              }
                            />
                          </span>
                          <label>Landmark</label>
                        </div>
                        <div
                          className={
                            styles.UserMgtUpdateFormContainerTwoListTwo
                          }
                        >
                          {form.landmark}
                        </div>
                      </div> */}
                    </div>
                  </div>
                </Paper>
              </>
            {/* ) : (
              <label>No Data</label>
            )} */}
          </div>
          {edit ? (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              <RedButton type="submit" sx={{height:"1.8rem"}} onClick={handleUpdate}>Update</RedButton>
              <GrayButton onClick={handleCancel} sx={{height:"1.8rem"}}>Cancel</GrayButton>
            </div>
          ) : null}
        </div>
      </form>
    </>
  );
};

export default UserMgtUpdateForm;
